import React, { useEffect, useState } from "react";
import { useSocket } from "./useSocket";

export const useCricketLiveSocket = (socketUrl, matchId) => {
    const [liveData, setLiveData] = useState(null);
    const socket = useSocket(socketUrl);

    useEffect(() => {
        if (socket && matchId) {

            const channelName = "CricketMatch";
            const eventName = `CricketMatchLive-${matchId}`;

            socket.channel(channelName).listen(eventName, (newData) => {
                console.log("Socket data received:", newData);
                setLiveData(newData?.data?.data || null);
            });

            return () => {
                socket?.connector?.socket.disconnect();
            };
        }
    }, [socket, matchId]);

    return liveData;
};
